import { CashMovement, CashSession } from '../types/cash';
import { TICKET_CSS } from './ticketStyles';

const EMPRESA = { nombre: 'REST CAMPESTRE LA OLLA DE JUANITA EIRL', ruc: '20223351205' };
const money = (n: any) => `S/ ${Number(n || 0).toFixed(2)}`;
const dollars = (n: any) => `US$ ${Number(n || 0).toFixed(2)}`;
const f = (d: any) => (d ? new Date(d).toLocaleString('es-PE') : '-');
const esc = (v: any) =>
  String(v ?? '').replace(/[&<>"']/g, (c) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
  }[c] as string));

// Imprime/abre el ticket de arqueo (cierre) de una sesion de caja.
// movements es opcional: si viene, se detallan los gastos/egresos del turno.
export function printCierreTicket(s: CashSession, movements?: CashMovement[]) {
  const expenses = (movements || []).filter((m) => m.type === 'egreso');
  const diff = Number(s.difference || 0);
  const diffUsd = Number(s.differenceUsd || 0);
  const cuadradaPen = Math.abs(diff) < 0.01;
  const cuadradaUsd = Math.abs(diffUsd) < 0.01;
  const estado =
    cuadradaPen && cuadradaUsd
      ? 'CAJA CUADRADA'
      : `${cuadradaPen ? '' : diff > 0 ? 'SOBRANTE PEN' : 'FALTANTE PEN'}${
          cuadradaPen || cuadradaUsd ? '' : ' / '
        }${cuadradaUsd ? '' : diffUsd > 0 ? 'SOBRANTE USD' : 'FALTANTE USD'}`;
  const html = `<html><head><style>${TICKET_CSS}</style></head><body>
    <div class="center bold" style="font-size:15px;">${EMPRESA.nombre}</div>
    <div class="center">RUC: ${EMPRESA.ruc}</div>
    <div class="center" style="margin-top:4px;">ARQUEO / CIERRE DE CAJA</div>
    <div class="line"></div>
    <div>Caja #${s.id}</div>
    <div>Apertura: ${f(s.openedAt)}</div>
    <div>Cierre:   ${f(s.closedAt)}</div>
    <div>Cajero:   ${s.closedByName || s.openedByName || '-'}</div>
    <div>TC vigente: S/ ${Number(s.exchangeRate || 0).toFixed(4)} / US$</div>
    <div class="line"></div>
    <table>
      <tr><td>Fondo inicial PEN:</td><td class="right">${money(s.openingAmount)}</td></tr>
      <tr><td>Fondo inicial USD:</td><td class="right">${dollars(s.openingAmountUsd)}</td></tr>
    </table>
    <div class="line"></div>
    <table>
      <tr><td>Ventas efectivo PEN:</td><td class="right">${money(s.salesEfectivo)}</td></tr>
      <tr><td>Ventas efectivo USD:</td><td class="right">${dollars(s.salesEfectivoUsd)}</td></tr>
      <tr><td>Ventas Visa:</td><td class="right">${money(s.salesVisa)}</td></tr>
      <tr><td>Ventas Mastercard:</td><td class="right">${money(s.salesMastercard)}</td></tr>
      <tr><td>Ventas Yape:</td><td class="right">${money(s.salesYape)}</td></tr>
      <tr><td>Ventas Plin:</td><td class="right">${money(s.salesPlin)}</td></tr>
      <tr><td>Ventas Transfer.:</td><td class="right">${money(s.salesTransferencia)}</td></tr>
      <tr><td>Ventas Credito:</td><td class="right">${money(s.salesCredito)}</td></tr>
      <tr class="bold"><td>Total ventas:</td><td class="right">${money(s.totalSales)}</td></tr>
      <tr><td>Ingresos efectivo:</td><td class="right">${money(s.totalIngresos)}</td></tr>
      <tr><td>Gastos:</td><td class="right">${money(s.totalEgresos)}</td></tr>
      <tr><td>Pedidos:</td><td class="right">${s.ordersCount ?? 0}</td></tr>
    </table>
    ${expenses.length > 0 ? `
    <div class="line"></div>
    <div class="bold">Detalle de gastos</div>
    <table>
      ${expenses.map((m) => `<tr><td>${esc(m.concept)}</td><td class="right">${money(m.amount)}</td></tr>`).join('')}
    </table>` : ''}
    <div class="line"></div>
    <table>
      <tr class="bold"><td>Saldo final esperado PEN:</td><td class="right">${money(s.expectedCash)}</td></tr>
      <tr class="bold"><td>Efectivo contado PEN:</td><td class="right">${money(s.countedCash)}</td></tr>
      <tr class="bold"><td>Diferencia PEN:</td><td class="right">${money(s.difference)}</td></tr>
      <tr class="bold"><td>Saldo final esperado USD:</td><td class="right">${dollars(s.expectedCashUsd)}</td></tr>
      <tr class="bold"><td>Efectivo contado USD:</td><td class="right">${dollars(s.countedCashUsd)}</td></tr>
      <tr class="bold"><td>Diferencia USD:</td><td class="right">${dollars(s.differenceUsd)}</td></tr>
    </table>
    ${s.notes ? `<div class="line"></div><div>Obs: ${esc(s.notes)}</div>` : ''}
    <div class="line"></div>
    <div class="center bold">${estado}</div>
    <script>window.onload=function(){window.print();}</script>
  </body></html>`;
  const w = window.open('', '_blank', 'width=340,height=680');
  if (w) { w.document.write(html); w.document.close(); }
}
